/**
 * CORE MED & SCIENCE - Main JavaScript
 * Vanilla JS for interactivity
 */

(function() {
  'use strict';

  // Hero Carousel/Pagination
  function initHeroPagination() {
    const paginationDots = document.querySelectorAll('.pagination__dot');
    const slides = document.querySelectorAll('.hero__slide');
    
    if (paginationDots.length === 0 || slides.length === 0) return;

    function switchSlide(index) {
      // Remove active class from all slides and dots
      slides.forEach(slide => slide.classList.remove('hero__slide--active'));
      paginationDots.forEach(dot => dot.classList.remove('pagination__dot--active'));
      
      // Handle video playback - pause all videos first
      const allVideos = document.querySelectorAll('.hero__video');
      allVideos.forEach(video => {
        video.pause();
      });
      
      // Add active class to selected slide and dot
      if (slides[index]) {
        slides[index].classList.add('hero__slide--active');
        
        // Play video if it exists in the active slide
        const activeVideo = slides[index].querySelector('.hero__video');
        if (activeVideo) {
          activeVideo.play().catch(e => {
            // Handle autoplay restrictions
            console.log('Video autoplay prevented:', e);
          });
        }
      }
      if (paginationDots[index]) {
        paginationDots[index].classList.add('pagination__dot--active');
      }
      
      // Switch text content - synchronized with slide change using same timing
      // Both slides and text are updated together in this function, triggered by the same interval
      const textSlides = document.querySelectorAll('.hero__text-slide[data-slide-text]');
      
      textSlides.forEach(slide => {
        const slideIndex = parseInt(slide.getAttribute('data-slide-text'), 10);
        if (slideIndex === index) {
          slide.classList.add('hero__text-slide--active');
        } else {
          slide.classList.remove('hero__text-slide--active');
        }
      });
    }

    // Auto-play slider - customizable speed from theme settings
    let currentSlide = 0;
    let autoPlayInterval = null;
    
    // Get slide speed from theme settings (default to 2000ms if not set)
    const slideSpeed = (window.homepageHeroSettings && window.homepageHeroSettings.slideSpeed) || 2000;

    function startAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
      }
      autoPlayInterval = setInterval(function() {
        currentSlide = (currentSlide + 1) % slides.length;
        switchSlide(currentSlide);
      }, slideSpeed);
    }

    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    // Add click handlers to pagination dots
    paginationDots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        const slideIndex = parseInt(this.getAttribute('data-slide'), 10);
        currentSlide = slideIndex;
        switchSlide(slideIndex);
        // Restart auto-play timer when user manually clicks
        stopAutoPlay();
        startAutoPlay();
      });
    });

    // Play first slide's video on page load if it exists
    const firstSlide = slides[0];
    if (firstSlide && firstSlide.classList.contains('hero__slide--active')) {
      const firstVideo = firstSlide.querySelector('.hero__video');
      if (firstVideo) {
        firstVideo.play().catch(e => {
          // Handle autoplay restrictions
          console.log('Video autoplay prevented:', e);
        });
      }
    }

    // Start auto-play
    startAutoPlay();
  }

  // Mobile Menu Toggle
  function initMobileMenu() {
    const menuToggle = document.querySelector('.header__menu-toggle');
    const nav = document.querySelector('.header__nav');
    const body = document.body;
    
    if (menuToggle && nav) {
      function toggleMenu() {
        const isOpen = nav.classList.contains('nav--open');
        
        if (isOpen) {
          // Close menu
          nav.classList.remove('nav--open');
          menuToggle.setAttribute('aria-expanded', 'false');
          body.classList.remove('menu-open');
        } else {
          // Open menu
          nav.classList.add('nav--open');
          menuToggle.setAttribute('aria-expanded', 'true');
          body.classList.add('menu-open');
        }
      }
      
      // Toggle menu on button click
      menuToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleMenu();
      });
      
      // Close menu when clicking on nav links (except dropdown links and dropdown items)
      const navLinks = nav.querySelectorAll('.nav__link:not(.nav__link--dropdown)');
      navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          // Don't close if clicking on a dropdown link
          if (!link.classList.contains('nav__link--dropdown')) {
            // Small delay for smooth transition
            setTimeout(() => {
              nav.classList.remove('nav--open');
              menuToggle.setAttribute('aria-expanded', 'false');
              body.classList.remove('menu-open');
            }, 100);
          }
        });
      });
      
      // Close menu when clicking on dropdown item links (actual menu items)
      const dropdownLinks = nav.querySelectorAll('.nav__dropdown-link');
      dropdownLinks.forEach(link => {
        link.addEventListener('click', function() {
          // Small delay for smooth transition
          setTimeout(() => {
            nav.classList.remove('nav--open');
            menuToggle.setAttribute('aria-expanded', 'false');
            body.classList.remove('menu-open');
          }, 100);
        });
      });
      
      // Close menu when clicking outside (on the nav overlay itself)
      nav.addEventListener('click', function(e) {
        // If clicking directly on the nav (not on links or list items)
        if (e.target === nav) {
          toggleMenu();
        }
      });
      
      // Prevent clicks inside nav from closing menu
      const navList = nav.querySelector('.nav__list');
      if (navList) {
        navList.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }
      
      // Close menu on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && nav.classList.contains('nav--open')) {
          toggleMenu();
        }
      });
    }
  }

  // Dropdown Menu Toggle
  function initDropdownMenu() {
    const dropdownItems = document.querySelectorAll('.nav__item--has-dropdown');
    
    dropdownItems.forEach(item => {
      const dropdownLink = item.querySelector('.nav__link--dropdown');
      const dropdown = item.querySelector('.nav__dropdown');
      
      if (dropdownLink && dropdown) {
        // Check if we're on mobile/tablet
        function isMobile() {
          return window.innerWidth < 1024;
        }
        
        if (isMobile()) {
          // Mobile: Toggle on click
          dropdownLink.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Close other open dropdowns
            dropdownItems.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('nav__item--open');
              }
            });
            
            // Toggle current dropdown
            item.classList.toggle('nav__item--open');
          });
        } else {
          // Desktop: Handle hover
          item.addEventListener('mouseenter', function() {
            item.classList.add('nav__item--open');
          });
          
          item.addEventListener('mouseleave', function() {
            item.classList.remove('nav__item--open');
          });
        }
      }
    });
    
    // Close dropdowns when clicking outside (desktop)
    document.addEventListener('click', function(e) {
      if (window.innerWidth >= 1024) {
        dropdownItems.forEach(item => {
          if (!item.contains(e.target)) {
            item.classList.remove('nav__item--open');
          }
        });
      }
    });
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        // Close all dropdowns on resize
        dropdownItems.forEach(item => {
          item.classList.remove('nav__item--open');
        });
      }, 250);
    });
  }

  // Search Functionality
  function initSearch() {
    const searchInput = document.querySelector('.search__input');
    
    if (searchInput) {
      searchInput.addEventListener('focus', function() {
        this.parentElement.classList.add('search--active');
      });
      
      searchInput.addEventListener('blur', function() {
        this.parentElement.classList.remove('search--active');
      });
    }
  }

  // Testimonials Infinite Slider
  function initTestimonialsSlider() {
    const slider = document.querySelector('.testimonials-slider');
    const track = document.querySelector('.testimonials-slider__track');
    const slides = document.querySelectorAll('.testimonials-slider__slide:not(.testimonials-slider__slide--clone)');
    const paginationDots = document.querySelectorAll('.testimonials-slider__dot');
    
    if (!slider || !track || slides.length === 0) return;

    let currentPosition = 0;
    let isPaused = false;
    let animationId = null;
    const speed = 0.5; // pixels per frame (adjust for speed)

    // Get slide width including gap
    function getSlideWidth() {
      const firstSlide = slides[0];
      if (!firstSlide) return 0;
      const slideWidth = firstSlide.offsetWidth;
      const gap = parseInt(window.getComputedStyle(track).gap) || 30;
      return slideWidth + gap;
    }

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const slideWidth = getSlideWidth();
        const totalWidth = slideWidth * slides.length;
        const sliderWidth = slider.offsetWidth;
        const visibleSlides = Math.ceil(sliderWidth / slideWidth) || 3;
        const cloneSets = slides.length <= visibleSlides ? Math.max(2, Math.ceil(visibleSlides / slides.length) + 1) : 1;
        
        // Re-clone slides with new calculations
        cloneSlides();
      }, 250);
    });

    // Clone slides for infinite loop - clone both before and after
    function cloneSlides() {
      // Remove existing clones
      const existingClones = track.querySelectorAll('.testimonials-slider__slide--clone');
      existingClones.forEach(clone => clone.remove());

      // Calculate how many slides are visible at once
      const sliderWidth = slider.offsetWidth;
      const slideWidth = getSlideWidth();
      const visibleSlides = Math.ceil(sliderWidth / slideWidth) || 3;
      
      // Calculate how many clone sets we need to ensure no visible duplicates
      // We need enough clones so that when viewing original slides, duplicates aren't visible
      const cloneSets = slides.length <= visibleSlides ? Math.max(2, Math.ceil(visibleSlides / slides.length) + 1) : 1;

      // Clone multiple sets before original slides
      for (let i = 0; i < cloneSets; i++) {
        slides.forEach(slide => {
          const clone = slide.cloneNode(true);
          clone.classList.add('testimonials-slider__slide--clone');
          track.insertBefore(clone, track.firstChild);
        });
      }

      // Clone multiple sets after original slides
      for (let i = 0; i < cloneSets; i++) {
        slides.forEach(slide => {
          const clone = slide.cloneNode(true);
          clone.classList.add('testimonials-slider__slide--clone');
          track.appendChild(clone);
        });
      }
      
      // Start position at the beginning of original slides (after prepended clones)
      const totalWidth = slideWidth * slides.length;
      currentPosition = -totalWidth * cloneSets;
    }

    // Update pagination dots
    function updatePagination() {
      const slideWidth = getSlideWidth();
      const totalWidth = slideWidth * slides.length;
      // Calculate actual index accounting for cloned slides
      let normalizedPosition = currentPosition + totalWidth;
      const actualIndex = Math.floor(Math.abs(normalizedPosition) / slideWidth) % slides.length;
      
      paginationDots.forEach((dot, index) => {
        if (index === actualIndex) {
          dot.classList.add('testimonials-slider__dot--active');
        } else {
          dot.classList.remove('testimonials-slider__dot--active');
        }
      });
    }

    // Animate slider
    function animate() {
      if (isPaused) {
        animationId = requestAnimationFrame(animate);
        return;
      }

      const slideWidth = getSlideWidth();
      const totalWidth = slideWidth * slides.length;
      const sliderWidth = slider.offsetWidth;
      const visibleSlides = Math.ceil(sliderWidth / slideWidth) || 3;
      const cloneSets = slides.length <= visibleSlides ? Math.max(2, Math.ceil(visibleSlides / slides.length) + 1) : 1;
      
      // Move track
      currentPosition -= speed;
      
      // Seamlessly reset position when we've scrolled through all original slides
      // Jump back to the start of original slides (which looks identical due to clones)
      if (Math.abs(currentPosition) >= totalWidth * (cloneSets + 1)) {
        currentPosition += totalWidth;
      }
      
      // Prevent scrolling before the first clone set
      if (currentPosition > -totalWidth * cloneSets) {
        currentPosition = -totalWidth * cloneSets;
      }
      
      track.style.transform = `translateX(${currentPosition}px)`;
      updatePagination();
      
      animationId = requestAnimationFrame(animate);
    }

    // Handle video play on thumbnail click
    function setupVideoHandlers() {
      const allThumbnails = document.querySelectorAll('.testimonial-video__thumbnail');
      const allVideos = document.querySelectorAll('.testimonial-video');
      
      allThumbnails.forEach((thumbnail, index) => {
        // Find the corresponding video in the same wrapper
        const wrapper = thumbnail.closest('.testimonial-video-wrapper');
        const slide = wrapper ? wrapper.closest('.testimonials-slider__slide') : null;
        const video = wrapper ? wrapper.querySelector('.testimonial-video') : null;
        
        // Skip slides without play icons (non-interactive slides)
        if (!video || (slide && slide.classList.contains('testimonials-slider__slide--no-interaction'))) {
          return;
        }

        // Only set up handlers if play icon exists
        const playIcon = thumbnail.querySelector('.testimonial-video__play-icon');
        if (!playIcon) {
          return;
        }

        thumbnail.addEventListener('click', function(e) {
          e.stopPropagation();
          
          // Pause all other videos
          allVideos.forEach((v) => {
            if (v !== video) {
              v.pause();
              v.currentTime = 0;
              v.classList.remove('testimonial-video--playing');
              const thumb = v.closest('.testimonial-video-wrapper')?.querySelector('.testimonial-video__thumbnail');
              if (thumb) {
                thumb.classList.remove('testimonial-video__thumbnail--hidden');
              }
            }
          });

          // Toggle current video
          if (video.paused) {
            video.play();
            video.classList.add('testimonial-video--playing');
            thumbnail.classList.add('testimonial-video__thumbnail--hidden');
          } else {
            video.pause();
            video.classList.remove('testimonial-video--playing');
            thumbnail.classList.remove('testimonial-video__thumbnail--hidden');
          }
        });
      });

      // Handle video end
      allVideos.forEach((video) => {
        video.addEventListener('ended', function() {
          this.classList.remove('testimonial-video--playing');
          const wrapper = this.closest('.testimonial-video-wrapper');
          const thumbnail = wrapper?.querySelector('.testimonial-video__thumbnail');
          if (thumbnail) {
            thumbnail.classList.remove('testimonial-video__thumbnail--hidden');
          }
        });
      });
    }

    // Pause slider on hover
    slider.addEventListener('mouseenter', function() {
      isPaused = true;
    });

    slider.addEventListener('mouseleave', function() {
      isPaused = false;
    });

    // Initialize
    cloneSlides();
    setupVideoHandlers();
    track.style.transition = 'none'; // Disable CSS transitions for smooth animation
    track.style.willChange = 'transform';
    animate();
  }

  // Social Feed Slider
  function initSocialFeedSlider() {
    const slider = document.querySelector('.social-feed__slider');
    const track = document.querySelector('.social-feed__track');
    const slides = document.querySelectorAll('.social-feed__slide');
    const prevBtn = document.querySelector('.social-feed__arrow--prev');
    const nextBtn = document.querySelector('.social-feed__arrow--next');
    
    if (!slider || !track || slides.length === 0) return;

    let currentIndex = 0;
    let slideWidth = 0;
    let gap = 20;
    let visibleSlides = 1;
    let maxIndex = 0;

    // Calculate how many slides are visible and max scroll index
    function calculateVisibleSlides() {
      if (!slider || !track || slides.length === 0) return;
      
      const sliderWidth = slider.offsetWidth;
      const trackWidth = track.scrollWidth;
      const firstSlide = slides[0];
      if (!firstSlide) return;
      
      slideWidth = firstSlide.offsetWidth;
      gap = parseInt(window.getComputedStyle(track).gap) || 20;
      
      // If track width is less than or equal to slider width, all content is visible
      if (trackWidth <= sliderWidth) {
        visibleSlides = slides.length;
        maxIndex = 0;
        return;
      }
      
      // Calculate how many slides fit in the viewport
      visibleSlides = Math.floor((sliderWidth + gap) / (slideWidth + gap));
      visibleSlides = Math.max(1, visibleSlides); // At least 1
      
      // Calculate maximum index (last position where we can scroll)
      // maxIndex = total slides - visible slides
      maxIndex = Math.max(0, slides.length - visibleSlides);
    }

    // Update button states
    function updateButtonStates() {
      // If all slides are visible, disable both buttons
      if (slides.length <= visibleSlides) {
        if (prevBtn) {
          prevBtn.disabled = true;
          prevBtn.style.opacity = '0.5';
          prevBtn.style.cursor = 'not-allowed';
        }
        if (nextBtn) {
          nextBtn.disabled = true;
          nextBtn.style.opacity = '0.5';
          nextBtn.style.cursor = 'not-allowed';
        }
        return;
      }
      
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
        prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
        prevBtn.style.cursor = currentIndex === 0 ? 'not-allowed' : 'pointer';
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIndex;
        nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
        nextBtn.style.cursor = currentIndex >= maxIndex ? 'not-allowed' : 'pointer';
      }
    }

    // Update slider position
    function updateSlider() {
      const translateX = -(currentIndex * (slideWidth + gap));
      track.style.transform = `translateX(${translateX}px)`;
      updateButtonStates();
    }

    // Go to next slide
    function nextSlide() {
      calculateVisibleSlides();
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSlider();
      }
    }

    // Go to previous slide
    function prevSlide() {
      calculateVisibleSlides();
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    }

    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        calculateVisibleSlides();
        // Reset to valid position if current index exceeds max
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        updateSlider();
      }, 250);
    });

    // Initialize
    calculateVisibleSlides();
    updateSlider();

    // Touch/swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    if (slider) {
      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      });

      slider.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      });

      function handleSwipe() {
        calculateVisibleSlides();
        if (touchEndX < touchStartX - 50 && currentIndex < maxIndex) {
          nextSlide();
        }
        if (touchEndX > touchStartX + 50 && currentIndex > 0) {
          prevSlide();
        }
      }
    }
  }

  // FAQ Accordion
  function initFAQAccordion() {
    const faqItems = document.querySelectorAll('.faq__item');
    
    if (faqItems.length === 0) return;

    faqItems.forEach((item) => {
      const question = item.querySelector('.faq__question');
      
      if (!question) return;

      question.addEventListener('click', function() {
        const isActive = item.classList.contains('faq__item--active');
        
        // Close all items
        faqItems.forEach((otherItem) => {
          otherItem.classList.remove('faq__item--active');
          const otherQuestion = otherItem.querySelector('.faq__question');
          if (otherQuestion) {
            otherQuestion.setAttribute('aria-expanded', 'false');
          }
        });
        
        // Toggle current item
        if (!isActive) {
          item.classList.add('faq__item--active');
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  
  // Product Page Functionality
  function initProductPage() {
    // Handle subscription radio button selection
    const subscriptionRadios = document.querySelectorAll('.subscription-radio');
    if (subscriptionRadios.length > 0) {
      subscriptionRadios.forEach(radio => {
        radio.addEventListener('change', function() {
          // Remove active class from all labels
          document.querySelectorAll('.subscription-label').forEach(label => {
            label.classList.remove('subscription-label--active');
          });
          document.querySelectorAll('.one-time-label').forEach(label => {
            label.classList.remove('one-time-label--active');
          });

          // Add active class to selected label
          if (this.checked) {
            const label = document.querySelector(`label[for="${this.id}"]`);
            if (label) {
              if (label.classList.contains('one-time-label')) {
                label.classList.add('one-time-label--active');
              } else {
                label.classList.add('subscription-label--active');
              }
            }
          }
        });
      });

      // Initialize active state for checked radio on page load
      const checkedRadio = document.querySelector('.subscription-radio:checked');
      if (checkedRadio) {
        const label = document.querySelector(`label[for="${checkedRadio.id}"]`);
        if (label && label.classList.contains('subscription-label')) {
          label.classList.add('subscription-label--active');
        }
      }
    }

    // Handle one-time purchase quantity select
    const quantitySelector = document.querySelector('.one-time-quantity-selector');
    if (quantitySelector) {
      // Update price when quantity changes
      quantitySelector.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const price = selectedOption.getAttribute('data-price');
        const priceElement = document.querySelector('.one-time-price');
        if (priceElement && price) {
          priceElement.textContent = price;
        }
      });

      // Initialize price on page load
      const selectedOption = quantitySelector.options[quantitySelector.selectedIndex];
      const initialPrice = selectedOption.getAttribute('data-price');
      const priceElement = document.querySelector('.one-time-price');
      if (priceElement && initialPrice) {
        priceElement.textContent = initialPrice;
      }
    }

    // Handle form and quantity button selections
    const formButtons = document.querySelectorAll('.product-form-btn');
    if (formButtons.length > 0) {
      formButtons.forEach(btn => {
        btn.addEventListener('click', function() {
          formButtons.forEach(b => b.classList.remove('active'));
          this.classList.add('active');
        });
      });
    }

    const quantityButtons = document.querySelectorAll('.quantity-btn');
    if (quantityButtons.length > 0) {
      quantityButtons.forEach(btn => {
        btn.addEventListener('click', function() {
          quantityButtons.forEach(b => b.classList.remove('active'));
          this.classList.add('active');
        });
      });
    }

    // Handle product tabs
    const productTabs = document.querySelectorAll('.product-tab');
    if (productTabs.length > 0) {
      const tabContents = {
        'description': {
          title: 'Product Description',
          content: 'description-content'
        },
        'benefits': {
          title: 'Benefits',
          content: 'benefits-content'
        },
        'ingredients': {
          title: 'Ingredients',
          content: 'ingredients-content'
        },
        'warnings': {
          title: 'Warnings and Precautions',
          content: 'warnings-content'
        }
      };

      productTabs.forEach(tab => {
        tab.addEventListener('click', function() {
          // Remove active class from all tabs
          productTabs.forEach(t => t.classList.remove('active'));

          // Add active class to clicked tab
          this.classList.add('active');

          // Get the tab data
          const tabId = this.getAttribute('data-tab');
          const tabData = tabContents[tabId];

          // Update heading
          const titleElement = document.querySelector('.tab-content-title');
          if (titleElement && tabData) {
            titleElement.textContent = tabData.title;
          }

          // Hide all content
          document.querySelectorAll('.tab-content-body').forEach(content => {
            content.style.display = 'none';
          });

          // Show selected content
          const selectedContent = document.getElementById(tabData.content);
          if (selectedContent) {
            selectedContent.style.display = 'block';
          }
        });
      });
    }
  }

  // Custom Select Dropdown
  function initCustomSelect() {
    const wrapper = document.querySelector('.custom-select-wrapper');
    if (!wrapper) return;

    const select = wrapper.querySelector('.custom-select');
    const trigger = wrapper.querySelector('.custom-select__trigger');
    const options = wrapper.querySelectorAll('.custom-option');
    const nativeSelect = wrapper.querySelector('.flavor-dropdown-native');
    const triggerText = trigger.querySelector('span');

    if (!select || !trigger) return;

    // Toggle dropdown
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      select.classList.toggle('open');
    });

    // Handle option selection
    options.forEach(option => {
      option.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Remove selected class from all options
        options.forEach(opt => opt.classList.remove('selected'));
        // Add selected class to clicked option
        this.classList.add('selected');
        
        // Update trigger text
        if (triggerText) {
          triggerText.textContent = this.textContent;
        }
        
        // Update native select value
        const value = this.getAttribute('data-value');
        if (nativeSelect) {
          nativeSelect.value = value;
          // Trigger change event on native select
          const event = new Event('change', { bubbles: true });
          nativeSelect.dispatchEvent(event);
        }
        
        // Close dropdown
        select.classList.remove('open');
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!select.contains(e.target)) {
        select.classList.remove('open');
      }
    });
  }


  // Initialize all functionality when DOM is ready
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    initHeroPagination();
    initMobileMenu();
    initDropdownMenu();
    initSearch();
    initTestimonialsSlider();
    initSocialFeedSlider();
    initFAQAccordion();
    initProductPage();
    initCustomSelect();
  }

  // Start initialization
  init();
})();

